import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const CreatePriceQuoteFromOrderGuideDocument = gql`
  mutation CreatePriceQuoteFromOrderGuide(
    $chat_id: uuid!
    $variant_pack_ids: [uuid!]!
  ) {
    createPriceQuoteFromOrderGuide: createPriceQuoteFromVariantPacks(
      chat_id: $chat_id
      variant_pack_ids: $variant_pack_ids
    ) {
      price_quote_id
    }
  }
`;
export type CreatePriceQuoteFromOrderGuideMutationFn = Apollo.MutationFunction<
  Types.CreatePriceQuoteFromOrderGuideMutation,
  Types.CreatePriceQuoteFromOrderGuideMutationVariables
>;
export function useCreatePriceQuoteFromOrderGuideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.CreatePriceQuoteFromOrderGuideMutation,
    Types.CreatePriceQuoteFromOrderGuideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.CreatePriceQuoteFromOrderGuideMutation,
    Types.CreatePriceQuoteFromOrderGuideMutationVariables
  >(CreatePriceQuoteFromOrderGuideDocument, options);
}
export type CreatePriceQuoteFromOrderGuideMutationHookResult = ReturnType<
  typeof useCreatePriceQuoteFromOrderGuideMutation
>;
export type CreatePriceQuoteFromOrderGuideMutationResult =
  Apollo.MutationResult<Types.CreatePriceQuoteFromOrderGuideMutation>;
export type CreatePriceQuoteFromOrderGuideMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CreatePriceQuoteFromOrderGuideMutation,
    Types.CreatePriceQuoteFromOrderGuideMutationVariables
  >;
